import { render, staticRenderFns } from "./Live Posts.vue?vue&type=template&id=4f8bbe7f&"
import script from "./Live Posts.vue?vue&type=script&lang=js&"
export * from "./Live Posts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports